// ADR-041 "Skills" cluster: the bot Skills library page (src/pages/bot-skills/). Spread into the central LABELS in
// labels.ts. The portal's `t()` takes no variables, so `{n}`, `{name}` etc. are substituted by the caller with .replace().
export const BOT_SKILLS_LABELS = {
  navBotSkills: { en: 'Skills', he: 'מיומנויות' },
  bsTitle: { en: 'Skills', he: 'מיומנויות' },
  bsIntro: {
    en: 'A skill is a working method for one kind of situation. On every turn the bot searches the skills alongside the knowledge base and follows the ones whose "when to use" fits the conversation. A skill changes how the bot works a turn; it adds no facts and never overrides the bot\'s rules.',
    he: 'מיומנות היא שיטת עבודה לסוג מסוים של מצב. בכל תור הבוט מחפש במיומנויות במקביל למאגר הידע, ופועל לפי אלה שה"מתי להשתמש" שלהן מתאים לשיחה. מיומנות משנה את אופן העבודה של הבוט בתור; היא לא מוסיפה עובדות ולעולם לא גוברת על כללי הבוט.',
  },
  bsBotUseOff: {
    en: 'Skills are not switched on for bots yet (AiAgent.Skills.Enabled is off). You can prepare skills here; no bot reads them until the switch is on.',
    he: 'המיומנויות עדיין לא מופעלות עבור הבוטים (AiAgent.Skills.Enabled כבוי). אפשר להכין כאן מיומנויות; אף בוט לא קורא אותן עד שהמתג יופעל.',
  },
  bsBotUseOn: { en: 'Skills are switched on: bots read the enabled skills below.', he: 'המיומנויות מופעלות: הבוטים קוראים את המיומנויות הפעילות שלמטה.' },
  bsLoading: { en: 'Loading skills…', he: 'טוען מיומנויות…' },
  bsLoadError: { en: 'Could not load the skills.', he: 'לא ניתן היה לטעון את המיומנויות.' },
  bsEmpty: { en: 'No skills yet. Add one, or upload a .md or .txt file.', he: 'אין עדיין מיומנויות. הוסיפו אחת, או העלו קובץ ‎.md או ‎.txt.' },
  bsAdd: { en: 'Add skill', he: 'הוספת מיומנות' },
  bsUpload: { en: 'Upload .md / .txt', he: 'העלאת ‎.md / ‎.txt' },
  bsCount: { en: '{n} of {max} skills', he: '{n} מתוך {max} מיומנויות' },
  bsColName: { en: 'Name', he: 'שם' },
  bsColWhen: { en: 'When to use it', he: 'מתי להשתמש' },
  bsColBots: { en: 'Bots', he: 'בוטים' },
  bsColStatus: { en: 'Status', he: 'מצב' },
  bsColActions: { en: 'Actions', he: 'פעולות' },
  bsAllBots: { en: 'Every bot', he: 'כל הבוטים' },
  bsOn: { en: 'On', he: 'פעילה' },
  bsOff: { en: 'Off', he: 'כבויה' },
  bsEdit: { en: 'Edit', he: 'עריכה' },
  bsDelete: { en: 'Delete', he: 'מחיקה' },
  bsDeleteTitle: { en: 'Delete skill', he: 'מחיקת מיומנות' },
  bsDeleteMessage: {
    en: 'Delete the skill "{name}"? No bot will receive it from the next turn on. This cannot be undone.',
    he: 'למחוק את המיומנות "{name}"? אף בוט לא יקבל אותה החל מהתור הבא. לא ניתן לבטל פעולה זו.',
  },
  bsFormNew: { en: 'New skill', he: 'מיומנות חדשה' },
  bsFormEdit: { en: 'Edit skill', he: 'עריכת מיומנות' },
  bsFieldName: { en: 'Name', he: 'שם' },
  bsFieldWhen: { en: 'When to use it', he: 'מתי להשתמש' },
  bsFieldWhenHelp: {
    en: 'One or two sentences describing the situation. The turn is matched against this text, so describe the situation, not the steps.',
    he: 'משפט או שניים שמתארים את המצב. התור מותאם מול הטקסט הזה, לכן תארו את המצב ולא את הצעדים.',
  },
  bsFieldInstructions: { en: 'Instructions', he: 'הנחיות' },
  bsFieldInstructionsHelp: {
    en: 'How the bot should work in that situation (plain text or Markdown).',
    he: 'איך הבוט צריך לעבוד במצב הזה (טקסט רגיל או Markdown).',
  },
  bsFieldEnabled: { en: 'Enabled', he: 'פעילה' },
  bsFieldScope: { en: 'Which bots use it', he: 'אילו בוטים משתמשים בה' },
  bsScopeAll: { en: 'Every bot of this organization', he: 'כל הבוטים של הארגון' },
  bsScopeAgents: { en: 'Only the bots I choose', he: 'רק הבוטים שאבחר' },
  bsScopeNoAgents: { en: 'This organization has no bots yet.', he: 'לארגון הזה עדיין אין בוטים.' },
  bsChars: { en: '{n} / {max} characters', he: '{n} / {max} תווים' },
  bsFromFile: { en: 'From file: {name}', he: 'מקובץ: {name}' },
  bsFileTruncated: {
    en: 'The file was longer than the limit; the instructions were cut. Check the end before saving.',
    he: 'הקובץ ארוך מהמגבלה; ההנחיות קוצרו. בדקו את הסוף לפני השמירה.',
  },
  bsSave: { en: 'Save', he: 'שמירה' },
  bsCancel: { en: 'Cancel', he: 'ביטול' },
  bsSaving: { en: 'Saving…', he: 'שומר…' },
  bsErrName: { en: 'Enter a name (up to {max} characters).', he: 'הזינו שם (עד {max} תווים).' },
  bsErrWhen: { en: 'Describe when to use it ({min}-{max} characters).', he: 'תארו מתי להשתמש ({min}-{max} תווים).' },
  bsErrInstructions: { en: 'Enter the instructions (up to {max} characters).', he: 'הזינו את ההנחיות (עד {max} תווים).' },
  bsErrAgents: { en: 'Choose at least one bot, or choose every bot.', he: 'בחרו לפחות בוט אחד, או את כל הבוטים.' },
  bsErrDuplicate: { en: 'A skill with this name already exists.', he: 'כבר קיימת מיומנות בשם הזה.' },
  bsErrTooMany: { en: 'This organization already has the most skills allowed.', he: 'לארגון הזה כבר יש את מספר המיומנויות המרבי.' },
  bsErrFile: { en: 'That file could not be read. Use a .md, .markdown or .txt file in UTF-8, up to 256 KB.', he: 'לא ניתן היה לקרוא את הקובץ. השתמשו בקובץ ‎.md, ‎.markdown או ‎.txt בקידוד UTF-8, עד 256KB.' },
  bsErrSave: { en: 'The skill could not be saved.', he: 'לא ניתן היה לשמור את המיומנות.' },
  bsErrDelete: { en: 'The skill could not be deleted.', he: 'לא ניתן היה למחוק את המיומנות.' },
  bsTryTitle: { en: 'Try it', he: 'ניסיון' },
  bsTryHelp: {
    en: "Write a customer message and pick a bot to see how close the message is, by meaning, to each skill's \"when to use\". Bots use these scores only when skill selection is set to similarity. By default a small model chooses instead, reading the whole conversation, so a skill can apply even with a low score here.",
    he: "כתבו הודעת לקוח ובחרו בוט כדי לראות עד כמה ההודעה קרובה במשמעותה ל\"מתי להשתמש\" של כל מיומנות. הבוטים משתמשים בציונים האלה רק כשבחירת המיומנויות מוגדרת לפי דמיון. כברירת מחדל מודל קטן בוחר במקום זאת, וקורא את כל השיחה, כך שמיומנות יכולה לחול גם עם ציון נמוך כאן.",
  },
  bsTryBot: { en: 'Bot', he: 'בוט' },
  bsTryMessage: { en: 'Customer message', he: 'הודעת לקוח' },
  bsTryRun: { en: 'Check', he: 'בדיקה' },
  bsTryNone: { en: 'No skill fits this message.', he: 'אף מיומנות לא מתאימה להודעה הזו.' },
  bsTrySelected: { en: 'Would be used', he: 'תשמש' },
  bsTryBelow: { en: 'Below the bar', he: 'מתחת לסף' },
  bsTryBar: { en: 'Needed score: {min}', he: 'ציון נדרש: {min}' },
  bsTryError: { en: 'The check failed.', he: 'הבדיקה נכשלה.' },
} satisfies Record<string, { en: string; he: string }>;
